import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import ContentThumb from 'reactGarden/ContentsThumb'
import { GenericCarousel } from 'reactGarden/GenericCarousel'
import ShapeThumb from 'reactGarden/common/prop-types/ThumbContent'

import WishlistProviderMethods from 'reactSite/Wishlist/provider'

import { Widget } from '../components/Widget'

const baseStyles = ({ theme }) => css`
  padding: 0 6px;
  width: 240px;

  @media (min-width: ${theme.media.tablet}) {
    width: 373px;
  }
`

const ThumbWrapper = styled('div')(baseStyles)

const LastContentsCarousel = ({ widget }) => {
  const { items: contents, title } = widget

  const hasContents = contents.length > 0
  const renderSlides = item => (
    <ThumbWrapper key={item.id}>
      <ContentThumb item={item} />
    </ThumbWrapper>
  )

  return (
    hasContents && (
      <Widget title={title} withBackground noContentPadding>
        <WishlistProviderMethods>
          <GenericCarousel slidesPerView="auto" spaceBetween={3}>
            {contents.map(renderSlides)}
          </GenericCarousel>
        </WishlistProviderMethods>
      </Widget>
    )
  )
}

LastContentsCarousel.propTypes = {
  widget: PropTypes.shape({
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape(ShapeThumb)).isRequired
  }).isRequired
}

export default LastContentsCarousel
